import { useEffect, useState } from "react";

export function useScrollable(ref: React.RefObject<HTMLElement>) {
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const checkScrollable = () => {
      if (ref.current) {
        setIsScrollable(ref.current.scrollWidth > ref.current.clientWidth);
      }
    };

    checkScrollable();
    window.addEventListener("resize", checkScrollable);

    let observer: ResizeObserver | null = null;
    if (typeof ResizeObserver !== "undefined" && ref.current) {
      observer = new ResizeObserver(checkScrollable);
      observer.observe(ref.current);
    }

    return () => {
      window.removeEventListener("resize", checkScrollable);
      observer?.disconnect();
    };
  }, [ref]);

  return isScrollable;
}
